import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { GroupListModel } from '../models/GroupListModel';
import { GroupModel } from '../models/GroupModel';
import { AddGroupModel } from '../models/AddGroupModel';
import { QueryResponse } from '../../core/services/QueryResponse';
import { ModelResponse } from '../../core/services/ModelResponse';

@Injectable()
export class GroupService {
  constructor(public httpClient: HttpClient) {}

  getGroupList(page: number, pageSize: number, sort: string, sortDirection: string, searchTerm: string): Observable<QueryResponse<GroupListModel>> {
    var params = new HttpParams()
      .set('skip', (page * pageSize).toString())
      .set('take', pageSize.toString());
    if (sort) {
      params = params.set('sort', sort)
        .set('sortDirection', sortDirection);
    }
    if (searchTerm) {
      params = params.set('searchTerm', searchTerm);
    }
    return this.httpClient.get<QueryResponse<GroupListModel>>("/api/CustomerModule/Group/ListQuery", { params: params });
  }

  getGroup(key: string): Observable<ModelResponse<GroupModel>> {
    return this.httpClient.get<ModelResponse<GroupModel>>("/api/CustomerModule/Group/Get/" + key);
  }

  addGroup(addModel: AddGroupModel): Observable<ModelResponse<string>> {
    return this.httpClient.put<ModelResponse<string>>("/api/CustomerModule/Group/Add/", addModel);
  }

  reviseName(key: string, name: string): Observable<ModelResponse<string>> {
    return this.httpClient.post<ModelResponse<string>>(`/api/CustomerModule/Group/${key}/ReviseName`, { model: name });
  }
}



// WEBPACK FOOTER //
// ./src/app/customer/services/GroupService.ts